
import React from "react";
import DetailPageTemplate from "@/components/DetailPageTemplate";
import { Card, CardContent } from "@/components/ui/card";
import InventoryStatusHeader from "@/components/inventory/check/InventoryStatusHeader";
import InventorySearchBox from "@/components/inventory/check/InventorySearchBox";
import InventoryTable from "@/components/inventory/check/InventoryTable";
import { useInventoryCheck } from "@/hooks/inventory/useInventoryCheck";
import { Toaster } from "sonner";

const VoorraadCheck = () => {
  const {
    filteredItems,
    formattedDate,
    formattedTime,
    handleSearch,
    handleAiSearch
  } = useInventoryCheck();

  return (
    <DetailPageTemplate 
      title="Voorraad Check"
      description="Bekijk de status van de voorraad"
    >
      <Card>
        <CardContent className="pt-6">
          <InventoryStatusHeader 
            lastUpdatedDate={formattedDate}
            lastUpdatedTime={formattedTime}
          />
          
          <div className="mt-6">
            <InventorySearchBox 
              onSearch={handleSearch}
              onAiSearch={handleAiSearch}
            />
            
            <InventoryTable items={filteredItems} />
          </div>
        </CardContent>
      </Card>
      <Toaster position="top-right" />
    </DetailPageTemplate>
  );
};

export default VoorraadCheck;
